import type { ReactNode } from 'react'

/*
  StatCard — tarjeta de KPI. Envuelve `.stat-card` + `.stat-label` + `.stat-value`
  (con modificador de tono `.success/.warning/.danger/.info`) de index.css.
*/
export type StatTone = 'default' | 'success' | 'warning' | 'danger' | 'info'

interface StatCardProps {
  label: ReactNode
  value: ReactNode
  tone?: StatTone
}

export function StatCard({ label, value, tone = 'default' }: StatCardProps) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className={`stat-value${tone !== 'default' ? ` ${tone}` : ''}`}>{value}</div>
    </div>
  )
}
